import commonApi from './CommonApi.js';

export default {
	checkCountryHasForum: async (parameters) => {
		return await commonApi().get('/v1/forumSettings/checkCountryHasForum', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getSettings: async (parameters) => {
		return await commonApi().get('/v1/forumSettings/getSettings', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/forumSettings', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}